export default "__VITE_ASSET__62137f64__"